import { ReactNode } from 'react'
import { Typography } from '@mui/material'

import { useStyles } from './styles'

interface IProps {
  title: string | ReactNode
  node: ReactNode
}

export const CollapsedItem = ({ title, node }: IProps) => {
  const classes = useStyles()

  return (
    <li className={classes.collapsedItem}>
      <Typography className={classes.itemText}>{title}:</Typography>
      {node}
    </li>
  )
}
